/**
 * Update Task Template API
 * Feature: Generic Configurable Task System
 * Branch: 022-i-like-all
 */

import axiosInstance from '@/api/axiosInstance';
import { UpdateTaskTemplateRequest, TaskTemplateResponse } from './types';

export async function updateTaskTemplate(
  id: string,
  data: UpdateTaskTemplateRequest
): Promise<{ data: TaskTemplateResponse }> {
  const response = await axiosInstance.put<TaskTemplateResponse>(
    `/api/task-templates/${id}`,
    data
  );

  return { data: response.data };
}